/**
 * Created by Alex Aguilar on 7/5/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('generateFlights',{
                parent: 'app',
                url: '/generateFlights',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/adminFlight/generateFlight/generateFlights.html',
                        controller: 'generateFlightsCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabAdminFlights': ['tabService', function(tabService){
                                return tabService.getTabAdminFlights('generateFlights')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['generateFlight']);
                            }],
                            'itineraries': ['itineraryService', function(itineraryService){
                                return itineraryService.getItineraries()
                            }],
                            'generateFlights': ['generateFlightService', function(generateFlightService){
                                return generateFlightService.getGenerateFlights(true)
                            }]
                        }
                    }
                }
            })
            .state('generateItineraryDelete', {
                parent: 'generateFlights',
                url: '/generateFlights/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configGeneral/adminFlight/generateFlight/deleteGenerateItinerary.html',
                        controller: 'deleteGenerateItineraryCtrl',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve:{
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['generateFlight']);
                            }],
                            'generateFlight': ['generateFlightService', function(generateFlightService) {
                                return generateFlightService.getGenerateFlight($stateParams.id)
                            }],
                        }
                    }).result.then(function() {
                        $state.go('generateFlights', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
    }
})();
